import { Box, Paper, Skeleton } from "@mui/material";

export const ModelParamsViewerSkeleton = () => {
  return (
    <Box
      className="w-full pt-8 overflow-y-scroll"
      sx={{ maxHeight: "calc(100vh - 450px)", minHeight: 300 }}
    >
      <Paper variant="outlined" sx={{ padding: 2 }}>
        {/* Level 0 - Root nodes */}
        <Box sx={{ display: "flex", alignItems: "center", paddingY: 0.5 }}>
          <Skeleton
            variant="circular"
            width={24}
            height={24}
            sx={{ marginRight: 1 }}
          />
          <Skeleton
            variant="text"
            width={120}
            height={20}
            sx={{ marginRight: 1 }}
          />
          <Skeleton variant="text" width={200} height={20} />
        </Box>

        {/* Level 1 - First nested level */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            paddingLeft: "24px",
            paddingY: 0.5
          }}
        >
          <Skeleton
            variant="circular"
            width={24}
            height={24}
            sx={{ marginRight: 1 }}
          />
          <Skeleton
            variant="text"
            width={100}
            height={20}
            sx={{ marginRight: 1 }}
          />
          <Skeleton variant="text" width={150} height={20} />
        </Box>

        {/* Level 2 - Second nested level */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            paddingLeft: "48px",
            paddingY: 0.5
          }}
        >
          <Box sx={{ width: 32 }} />
          <Skeleton
            variant="text"
            width={80}
            height={20}
            sx={{ marginRight: 1 }}
          />
          <Skeleton variant="text" width={100} height={20} />
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            paddingLeft: "48px",
            paddingY: 0.5
          }}
        >
          <Box sx={{ width: 32 }} />
          <Skeleton
            variant="text"
            width={90}
            height={20}
            sx={{ marginRight: 1 }}
          />
          <Skeleton variant="text" width={120} height={20} />
        </Box>

        {/* Level 1 - Another nested level */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            paddingLeft: "24px",
            paddingY: 0.5
          }}
        >
          <Skeleton
            variant="circular"
            width={24}
            height={24}
            sx={{ marginRight: 1 }}
          />
          <Skeleton
            variant="text"
            width={110}
            height={20}
            sx={{ marginRight: 1 }}
          />
          <Skeleton variant="text" width={180} height={20} />
        </Box>

        {/* Level 0 - Another root node */}
        <Box sx={{ display: "flex", alignItems: "center", paddingY: 0.5 }}>
          <Skeleton
            variant="circular"
            width={24}
            height={24}
            sx={{ marginRight: 1 }}
          />
          <Skeleton
            variant="text"
            width={140}
            height={20}
            sx={{ marginRight: 1 }}
          />
          <Skeleton variant="text" width={220} height={20} />
        </Box>

        {/* Level 1 */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            paddingLeft: "24px",
            paddingY: 0.5
          }}
        >
          <Box sx={{ width: 32 }} />
          <Skeleton
            variant="text"
            width={95}
            height={20}
            sx={{ marginRight: 1 }}
          />
          <Skeleton variant="text" width={140} height={20} />
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            paddingLeft: "24px",
            paddingY: 0.5
          }}
        >
          <Box sx={{ width: 32 }} />
          <Skeleton
            variant="text"
            width={85}
            height={20}
            sx={{ marginRight: 1 }}
          />
          <Skeleton variant="text" width={130} height={20} />
        </Box>

        {/* Level 0 - Another root node */}
        <Box sx={{ display: "flex", alignItems: "center", paddingY: 0.5 }}>
          <Skeleton
            variant="circular"
            width={24}
            height={24}
            sx={{ marginRight: 1 }}
          />
          <Skeleton
            variant="text"
            width={100}
            height={20}
            sx={{ marginRight: 1 }}
          />
          <Skeleton variant="text" width={160} height={20} />
        </Box>

        {/* Table-like skeleton for array data */}
        <Box sx={{ paddingLeft: "24px", paddingTop: 1, paddingBottom: 1 }}>
          <Skeleton
            variant="rectangular"
            height={150}
            sx={{ borderRadius: 1 }}
          />
        </Box>
      </Paper>
    </Box>
  );
};
